import { useQuery } from "@tanstack/react-query";
import { createLogger } from "logging";
import { useApi, useBoardSettings } from "providers";
import React, { PropsWithChildren, useMemo } from "react";

import { BoardStatisticsContext } from "./BoardStatisticsContext";

const logger = createLogger("BoardStatisticsProvider");

export const BoardStatisticsProvider: React.FC<PropsWithChildren> = ({ children }) => {
  const { boardApi } = useApi();
  const { boardId } = useBoardSettings();

  const queryResult = useQuery({
    queryKey: [`BoardStatistics|${boardId}`],
    queryFn: async ({ signal }) => {
      const data = await boardApi.getBoardStatistics(boardId, signal);
      logger.trace("Loaded", data);
      return data;
    },
    enabled: !!boardId,
    staleTime: 0,
  });
  const statistics = queryResult.data;
  const isLoading = queryResult.isFetching;
  const contextValue = useMemo(() => ({ statistics, isLoading }), [statistics, isLoading]);

  return <BoardStatisticsContext.Provider value={contextValue}>{children}</BoardStatisticsContext.Provider>;
};
